import React from 'react';
import { NotifyProduct } from '@ifixit/product-page-components';
import { useSelectedOptionid } from '../shared-state';
import initializeComponent from '../Shared/react-initialize';
import styled from 'styled-components';

const StyledNotifyProduct = styled(NotifyProduct)`
   margin-top: 20px;
   display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

const US_ID = 1;

const NotifyProductWrapper = ({ email }) => {
   const [optionid] = useSelectedOptionid();

   if (!optionid) {
      return null;
   }

   const optionInfo = App.options.find(option => option.optionid === parseInt(optionid));

   return (
      <StyledNotifyProduct
         key={optionid}
         hidden={!optionInfo || optionInfo.avail}
         email={email}
         sku={'' + App.productcode + optionid}
         salesChannelID={US_ID}
         baseUrl={window.location.origin + '/api/2.0/'}
      />
   );
};

initializeComponent('NotifyProduct', NotifyProductWrapper);
export default NotifyProductWrapper;
